import clsx from 'clsx'
import { FC } from 'react'

import { FilterDisplayType } from '@/entities/catalog-brands'

import { Chip } from '@/shared/ui/chip'

import { useAppliedFilters } from '../hooks/useAppliedFilters'

import cls from './applied-filters.module.scss'

export type AppliedFiltersProps = {
	className?: string
	clearInStart?: boolean
	onChange?: (value: string) => void
}

export const AppliedFilters: FC<AppliedFiltersProps> = ({ className = '', clearInStart, onChange }) => {
	const { items, deleteItem, isLoading, clearAll } = useAppliedFilters({ onChange })

	if (!items?.length) return null

	return (
		<div className={clsx(cls.appliedFilters, className)}>
			{clearInStart && !!items.length && (
				<Chip theme="outlined" label="Очистить все" onDelete={clearAll} isDisabled={isLoading} />
			)}
			{items?.map(({ name, id, value, code, displayType }) => {
				if (code !== `PRICE`) {
					return (
						<Chip
							theme="accent"
							key={id}
							label={displayType === FilterDisplayType.Radio ? name : value}
							onDelete={() => deleteItem?.(id)}
							isDisabled={isLoading}
						/>
					)
				}
			})}
			{!clearInStart && !!items.length && (
				<Chip theme="outlined" label="Очистить все" onDelete={clearAll} isDisabled={isLoading} />
			)}
		</div>
	)
}
